export const colorWithOpacity = (color, opacity) => {
  // Check if color is already in rgba format
  if (color.startsWith('rgba')) {
    // Extract rgba components and replace the alpha value with the new opacity
    // eslint-disable-next-line no-useless-escape
    return color.replace(/[\d\.]+\)$/g, `${opacity})`);
  }

  // Check if color is in hex format
  if (color.startsWith('#')) {
    let r, g, b;

    // Handle 6-digit hex (e.g. #RRGGBB) or 8-digit hex (e.g. #RRGGBBAA)
    if (color.length === 7) {
      // #RRGGBB
      r = parseInt(color.slice(1, 3), 16);
      g = parseInt(color.slice(3, 5), 16);
      b = parseInt(color.slice(5, 7), 16);
    } else if (color.length === 9) {
      // #RRGGBBAA (if opacity is included in the hex)
      r = parseInt(color.slice(1, 3), 16);
      g = parseInt(color.slice(3, 5), 16);
      b = parseInt(color.slice(5, 7), 16);
      // Ignore the alpha part (last two characters)
    } else {
      throw new Error('Invalid hex color format');
    }

    // Return rgba with the specified opacity
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  throw new Error('Invalid color format. Supported formats: hex (#RRGGBB or #RRGGBBAA) and rgba.');
};
